function Two() {
    return (
        <div className="flex w-full bg-[#f9f9f9] p-2 rounded-sm items-center flex-col md:flex-row" id='promise2'> {/* Added bg-gray-100 for a light gray background */}
                <div className="hidden md:block w-full md:w-4/12"> {/* Added full width for consistency */}
                <div className="promise-image-column w-full p-4">
                    <img src="/halo-promise/2.png" alt="24/7 Toll-Free Holiday Hotline" className="w-full h-auto object-contain" />
                </div>
            </div>
            <div className="benefits-divider w-1/12 bg-gray-300 min-h-full"></div> {/* Ensured divider reaches full height */}
            <div className="benefits-details w-full md:w-7/12 p-4"> {/* Added padding for better content spacing */}
                <h2 className="text-lg md:text-xl font-bold mb-6 mt-4 text-black leading-tight inline-block relative">
                    <span className="relative z-10">Easy Payment Plans</span>
                    <span className="absolute -bottom-2 left-0 h-1 rounded-md w-[50%] bg-gradient-custom -z-0"></span>
                </h2>

                <p className="text-sm text-black mb-4">Planning a holiday shouldn’t feel like a financial mountain to climb, and that’s why our <span className="text-halo-pink">Flexible Payment Plans</span> make it as easy as ever to book your dream holiday.</p>

                <p className="text-sm text-black mb-4">Imagine spreading the cost of your trip over a period that suits you—without any hidden fees. Our simple, flexible payment solutions mean you get to plan your adventure without any budget woes.</p>

                <h3 className="text-lg font-semibold mb-4 mt-4">Why You'll Love This</h3>
                <ul className="custom-bullet pl-5 space-y-2 text-black text-sm">
                    <li><span className="font-medium text-black">Stress-Free Budgeting</span> – Pay over time with easy installments, and manage your budget the way that fits you best.</li>
                    <li><span className="font-medium text-black">No Surprises</span> – Clear, transparent plans so you always know exactly where you stand.</li>
                    <li><span className="font-medium text-black">Peace of Mind</span> – Rest easy knowing your holiday is secure and affordable.</li>
                </ul>

                <div className="bg-white rounded-lg p-4 mt-4"> {/* New container with background */}
                    <div className="flex items-center">
                        <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-6 h-6 mr-2" />
                        <h3 className="text-lg font-semibold">Our Promise</h3>
                    </div>
                    <p className="text-black mt-2">Every dream destination should be accessible, and we make it possible by providing stress-free payment options tailored to your needs.</p>
                </div>
            </div>

        </div>
    );
}

export default Two;